
export interface OlapEtlTable {
    tableName: string;
    documentIdColumn: string;
}